module.exports = __webpack_public_path__ + "img/video-mr-bricolage.624ec0e.jpg";